import * as React from 'react'

import { cn } from '@/lib/utils'

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-9 w-full rounded-lg border !border-gray-200 !bg-gray-50 px-3 py-1.5 text-sm transition-all duration-200 file:border-0 file:bg-transparent file:text-sm file:font-normal !text-gray-900 placeholder:!text-gray-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:!ring-gray-200 focus-visible:!border-gray-300 disabled:cursor-not-allowed disabled:opacity-40 disabled:!bg-gray-50',
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = 'Input'

export { Input }
